import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSword: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sword, action, gaming"><path d="M8.25 11.0543L13.9891 3.75H20.25V10.0109L12.9457 15.75" stroke="currentColor" strokeWidth="1.5"/><path d="M6.40217 9.25L4.31522 11.8587L6.40217 14.9891L2.75 18.6413L5.3587 21.25L9.01087 17.5978L12.1413 19.6848L14.75 17.5978L6.40217 9.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSword;
